import Link from "@/components/common/Link";
import { PATH } from "@/constants/path";

interface DownloadCompanyIntroButtonProps {
  onClick?: () => void;
}

function DownloadCompanyIntroButton({ onClick }: DownloadCompanyIntroButtonProps) {
  return <Link className="font-light" size="sm" href={PATH.BLOG} text="더 많은 이야기 읽어보기" onClick={onClick} />;
}
export default DownloadCompanyIntroButton;
